// window.__ENV__ est injecté au runtime par le conteneur Docker (public/env.js).
// eslint-disable-next-line no-underscore-dangle
const runtime = (typeof window !== 'undefined' && window.__ENV__) || {}

export default {
  API_URL: runtime.API_URL || 'http://localhost:3000/',
  SOCKET_URL: runtime.SOCKET_URL || 'http://localhost:3000',
}
